/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SuggestRiskPolicyRequestBody = {
  /**
   * Plain-language description of what the policy should catch or prevent.
   */
  prompt: string;
};

/** @internal */
export type SuggestRiskPolicyRequestBody$Outbound = {
  prompt: string;
};

/** @internal */
export const SuggestRiskPolicyRequestBody$outboundSchema: z.ZodMiniType<
  SuggestRiskPolicyRequestBody$Outbound,
  SuggestRiskPolicyRequestBody
> = z.object({
  prompt: z.string(),
});

export function suggestRiskPolicyRequestBodyToJSON(
  suggestRiskPolicyRequestBody: SuggestRiskPolicyRequestBody,
): string {
  return JSON.stringify(
    SuggestRiskPolicyRequestBody$outboundSchema.parse(
      suggestRiskPolicyRequestBody,
    ),
  );
}
